import styled from 'styled-components';

export const Container = styled.div`
  border-color: ${(props) => props.theme.$gray300};
  border-radius: 8px;

  &.is-open {
    border-color: ${(props) => props.theme.$primary};
  }

  &.is-ignored .requirement-title {
    color: ${(props) => props.theme.$gray600};
    text-decoration: line-through;
  }

  .min-w-0 {
    min-width: 0;
  }

  .requirement-title {
    color: ${(props) => props.theme.$dark};
    font-size: 16px;
    font-weight: 600;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
  }

  .requirement-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;

    .material-icons {
      font-size: 20px;
    }
  }

  .requirement-section-title {
    color: ${(props) => props.theme.$dark};
    font-weight: 600;
  }

  .requirement-text,
  .requirement-excerpt {
    white-space: pre-line;
    word-break: break-word;
  }

  .btn-link .material-icons {
    font-size: 18px;
  }

  .requirement-files {
    border-color: ${(props) => props.theme.$gray300};
    border-radius: 8px;
    overflow: hidden;

    .table th {
      border-top: 0;
      color: ${(props) => props.theme.$dark};
      font-weight: 600;
    }

    .table td {
      color: ${(props) => props.theme.$gray700};
    }

    .file-name {
      min-width: 220px;
      word-break: break-word;
    }

    .file-preview-row td {
      border-top: 0;
    }

    .file-actions .btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .file-actions .material-icons {
      font-size: 16px;
      line-height: 1;
    }
  }
`;
